import React, { createContext, useState, useEffect } from "react";
import type { Moneda } from "@/schemas/common";

const CURRENCY_PREF_KEY = "global-currency-preference";

interface CurrencyContextType {
	currencyPreference: Moneda | null;
	setCurrencyPreference: (currency: Moneda) => void;
	// We can store restrictions globally if needed
	availableCurrencies: Moneda[];
	setAvailableCurrencies: (currencies: Moneda[]) => void;
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(undefined);

export { CurrencyContext };

export const CurrencyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [currencyPreference, setCurrencyPreferenceState] = useState<Moneda | null>(null);
	const [availableCurrencies, setAvailableCurrencies] = useState<Moneda[]>(["USD", "PEN", "EUR"]);

	useEffect(() => {
		try {
			const storedPreference = localStorage.getItem(CURRENCY_PREF_KEY);
			if (
				storedPreference === "PEN" ||
				storedPreference === "USD" ||
				storedPreference === "EUR"
			) {
				setCurrencyPreferenceState(storedPreference as Moneda);
			}
		} catch {
			// ignore
		}
	}, []);

	const setCurrencyPreference = (option: Moneda) => {
		setCurrencyPreferenceState(option);
		try {
			localStorage.setItem(CURRENCY_PREF_KEY, option);
		} catch {
			// ignore
		}
	};

	return (
		<CurrencyContext.Provider
			value={{
				currencyPreference,
				setCurrencyPreference,
				availableCurrencies,
				setAvailableCurrencies,
			}}
		>
			{children}
		</CurrencyContext.Provider>
	);
};
